import React from 'react';

const HANDS_IMAGE =
  'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/r2fsp58k_freepik__escena-4-artesana-y-origen-retrato-de-mara-la-crea__52049.png';

const ManifiestoSection = () => (
  <section
    id="manifiesto"
    data-testid="manifiesto-section"
    className="py-20 md:py-32 bg-[#F5F0E8]"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">

        {/* Image Block */}
        <div className="relative">
          <div className="aspect-[4/5] overflow-hidden">
            <img
              src={HANDS_IMAGE}
              alt="Elaboración artesanal de croquetas"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          {/* Gold accent square */}
          <div className="absolute -bottom-5 -right-5 w-28 h-28 bg-[#D4A853] hidden md:flex items-center justify-center p-3">
            <span className="font-serif text-white text-xs text-center font-bold uppercase tracking-wide leading-snug">
              Hecho<br />a Mano
            </span>
          </div>
          {/* Vino accent line */}
          <div className="absolute top-0 left-0 w-1 h-24 bg-[#7B1F3A]" />
        </div>

        {/* Text Block */}
        <div className="md:pl-4">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#7B1F3A] mb-4">
            El Manifiesto
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#2C2C2A] leading-tight mb-8">
            Somos una Cocina.
            <br />
            No somos
            <br />
            una fábrica.
          </h2>
          <div className="space-y-5 text-[#888780] text-base leading-relaxed">
            <p>
              No buscamos atajos. No usamos conservantes. No producimos en
              serie. Cada croqueta que sale de nuestras manos lleva tiempo,
              cariño y los mejores ingredientes que podemos encontrar.
            </p>
            <p>
              Creemos que lo artesanal no es solo una palabra bonita: es una
              forma de hacer las cosas. Es elegir el camino largo porque el
              resultado se nota.
            </p>
            <p className="font-medium text-[#2C2C2A]">
              En cada bocado. En cada textura. En cada crujido.
            </p>
            <p className="font-medium text-[#2C2C2A] border-l-4 border-[#D4A853] pl-4">
              Esto es Las Croquetas de María. Hechas como las de siempre,
              pero mejor.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ManifiestoSection;
